export interface ClusterGroup {
  code: string;
  name: string;
  description?: string;
  orderIdx: number;
  clusterItems: ClusterItem[];
}

export interface ClusterItem {
  code: string;
  text: string;
  imageUrl?: string;
  activeImageUrl?: string;
  orderIdx: number;
}

export interface TechValueDef {
  label: string;
  code: string;
}

export enum TemperatureUnit {
  Celsius = "celsius",
  Fahrenheit = "fahrenheit",
}

export enum NumberSystem {
  Metric = "metric",
  Imperial = "imperial",
}
